import React from 'react';
import classNames from 'classnames';
import { Box } from '@spothero/ui';
import { useDispatch } from 'react-redux';
import { setPriceBreakdownModalSpotId } from 'store/search/search-actions';
import { Price } from 'common/facility-summary/price';
import { usePrice } from 'hooks/spot/price/use-price';
import { getSpotheroOversizeFee } from 'utils/search-vehicle';
import { useLabel } from 'hooks/spot/price/use-label';
import { getAirportPriceWODiscount } from 'utils/airport/price-utils';
// Renders the responsive price component for AIRPORT parking spot
const ResponsivePrice = ({ spot }) => {
    const dispatch = useDispatch();
    const priceObject = usePrice(spot);
    const labelForAirport = useLabel({ selectedRate: spot?.selectedRate });
    const oversizeFee = getSpotheroOversizeFee(spot);
    const priceWithoutDiscount = getAirportPriceWODiscount({
        selectedRate: spot?.selectedRate,
    });
    const labelOversizeIncluded = oversizeFee.isOversize
        ? 'Total*'
        : labelForAirport;
    const additionalStyles = classNames({
        Oversize: oversizeFee.isOversize,
        'apply-airport-width': true,
    });
    const handleOnShowPriceBreakdown = () => {
        dispatch(setPriceBreakdownModalSpotId(spot?.spotId));
    };
    return oversizeFee.isOversize ? (<Box minWidth={{ base: '88px', tablet: '120px' }}>
            <Price oversizeFee={oversizeFee} priceWithoutDiscount={priceWithoutDiscount} price={priceObject} additionalStyles={additionalStyles} priceLabel={labelOversizeIncluded} hasMultipleRates={spot?.hasMultipleRates} onShowPriceBreakdown={handleOnShowPriceBreakdown} textToAppend="/day"/>
        </Box>) : (<Box>
            <Price priceWithoutDiscount={priceWithoutDiscount} price={priceObject} additionalStyles={additionalStyles} priceLabel={labelForAirport} hasMultipleRates={spot?.hasMultipleRates} onShowPriceBreakdown={handleOnShowPriceBreakdown} textToAppend="/day"/>
        </Box>);
};
export default ResponsivePrice;
